import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData,
} from 'lightweight-charts';
import { VolumeCandleData } from './data';
import { VolumeCandleSeriesOptions, defaultVolumeCandleOptions } from './options';
import { VolumeCandleRenderer } from './renderer';

export class VolumeCandleSeries
    implements ICustomSeriesPaneView<Time, VolumeCandleData, VolumeCandleSeriesOptions> {
    _renderer: VolumeCandleRenderer;

    constructor() {
        this._renderer = new VolumeCandleRenderer();
    }

    priceValueBuilder(plotRow: VolumeCandleData): CustomSeriesPricePlotValues {
        return [plotRow.high, plotRow.low, plotRow.close, plotRow.open];
    }

    isWhitespace(data: VolumeCandleData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<VolumeCandleData>).close === undefined;
    }

    renderer(): VolumeCandleRenderer {
        return this._renderer;
    }

    update(
        data: PaneRendererCustomData<Time, VolumeCandleData>,
        options: VolumeCandleSeriesOptions
    ): void {
        this._renderer.update(data, options);
    }

    defaultOptions() {
        return defaultVolumeCandleOptions;
    }
}
